import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { CondominioService } from '@app/core/services/condominio.service';
import { AppService } from '@app/core/services/app.service';
import { PreCadastroService } from '@app/core/services/pre-cadastro.service';

@Component({
  selector: 'app-confirm-trasnfer-pre-cadastro',
  templateUrl: './confirm-trasnfer-pre-cadastro.component.html',
  styleUrls: ['./confirm-trasnfer-pre-cadastro.component.scss']
})
export class ConfirmTrasnferPreCadastroComponent {

  options: { text: string, value: any, cssClass: string, icon?: string, actionModal: string }[] = [
    { text: 'Cancelar', value: false, cssClass: 'btn btn-link', actionModal: 'close' },
    { text: 'Continuar', value: true, cssClass: 'btn-sm bg-gradient circle', actionModal: '' }
  ];
  title: string = 'Deseja realmente migrar os dados ?';
  message: string = 'Já conferiu os dados do condomínio ? cliente ciente dessa ação ? Essa ação irá migrar os dados de pre cadastro para ativo e criar um novo condomínio. ';
  pathImage: string = 'assets/transfer-dados.png';
  form: UntypedFormGroup;
  condominio: any;
  saving: boolean = false;
  buttonDisabled: boolean = false;
  termo: boolean = true;

  constructor(
    public activeModal: NgbActiveModal,
    private condominioServ: CondominioService,
    private modal: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private app: AppService,
    private precadastro: PreCadastroService,
  ) {
    this.form = new UntypedFormGroup({
      aceito: new UntypedFormControl(false, Validators.required)
    });
  }



  setMessage(message: string | Array<string>) {
    const messageMerge = message instanceof Array ? message.join('<br>') : message;
    this.message = messageMerge;
  }

  ngOnInit() {

  }

  async save(value, actionModal) {
    // event.preventDefault();
    if (actionModal != 'close') {
      this.saving = true;
      let condominio: any = this.condominio.condominios[0];
      condominio.freemium = Boolean(condominio.plano);
      let novoCondominio = {
        condominio: condominio.condominioId,
        cnpj: await this.app.converterDocumento(condominio.numeroDoDocumento),
        nome: condominio.nomeDoCondominio,
        descricao: '',
        logoMarca: '',
        nomeOriginal: '',
        telefone: condominio.telefone,
        logradouro: condominio.logradouro,
        complemento: condominio.complemento,
        numero: condominio.numero,
        cep: condominio.cep,
        bairro: condominio.bairro,
        cidade: condominio.cidade,
        estado: condominio.estado,
        nomeDoSindico: condominio.nomeDoSindico,
        telefoneDoSindico: condominio.telefoneDoSindico,
        celularDoSindico: condominio.telefoneDoSindico,
        emailDoSindico: condominio.emailDoSindico,

        portaria:  condominio.plano == 1 ? false : true,
        portariaMorador:  condominio.plano == 1 ? false : true,
        classificado:  condominio.plano == 1 ? true : false,
        classificadoMorador:  condominio.plano == 1 ? true : false,
        mural:  condominio.plano == 1 ? true : false,
        muralMorador:  condominio.plano == 1 ? true : false,
        chat:  condominio.plano == 1 ? true : false,
        chatMorador:  condominio.plano == 1 ? true : false,
        reserva:  condominio.plano == 1 ? false : true,
        reservaNaPortaria:  condominio.plano == 1 ? false : true,
        ocorrencia:  condominio.plano == 1 ? true : false,
        ocorrenciaMorador:  condominio.plano == 1 ? true : false,
        correspondencia:  condominio.plano == 1 ? true : false,
        correspondenciaNaPortaria:  condominio.plano == 1 ? true : false,
        limiteTempoReserva:  condominio.plano == 1 ? true : false,

        freemium: condominio.plano == 1 ? true : false,
      }
      this.options = [
        {
          text: 'Carregando...',
          value: true,
          cssClass: 'btn-sm bg-gradient circle',
          icon: 'spinner-border spinner-border-sm',
          actionModal: ''
        }
      ];

      let response: any = await this.condominioServ.adicionarCondominio(novoCondominio);
      
      if (response.status == 0) {
        this.activeModal.close("close");
        this.saving = false;

        const condoTransferido = {
          condominioId: this.condominio.condominios[0].condominioId,
          leadId: this.condominio.leadId
        };


        const modalRef = await this.modal.open(ConfirmTrasnferPreCadastroComponent, { centered: true });

        modalRef.componentInstance.title = 'Migração realizada com sucesso!';
        modalRef.componentInstance.pathImage = 'assets/concluded-transfer-dados.png';

        modalRef.componentInstance.options = [
          { text: 'Concluir', value: true, cssClass: 'btn-sm bg-gradient circle', actionModal: 'close' }
        ];

        modalRef.componentInstance.message = 'Os dados foram migrados com sucesso, você poderar visualizar na lista de condomínios.';
        modalRef.componentInstance.termo = false;

        await this.precadastro.tranferirCondominio(condoTransferido);
        this.router.navigateByUrl('/dashboard/pre-cadastro/pre-cadastro-list');

        modalRef.result;
      } else {
        this.app.alert(response.mensagem, 'Erro');
      }
      this.saving = false;
    }
    this.saving = false;
    this.activeModal.close('')
  }
}
